import { useEffect, useState } from "react";
import DynamicBanner from "../../include/DynamicBanner";
import DynamicPdfCard from "../../include/DynamicPdfCard";
import api from '../../../../api';

const EnvironmentalClearance = () => {
  const [loaded, setLoaded] = useState(false);
  const [banner, setBanner] = useState(null);
  const [cardData, setCardData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const fetchData = async () => {
      try {
        const res = await api.get("/api/sitepages/about-us/environmental-clearance");
        const data = res.data || {};

        if (cancelled) return;

        setBanner(data.banner_data ?? null);
        setCardData(data.card_data ?? null);
        setError(null);
      } catch (err) {
        console.error("Error fetching Environmental Clearance:", err);
        if (!cancelled) setError(err);
      } finally {
        if (!cancelled) setLoaded(true);
      }
    };

    fetchData();
    return () => {
      cancelled = true;
    };
  }, []);

  if (!loaded) return null;

  if (error) return null;
  if (!banner && !cardData) return null;

  return (
    <>
     <section className="e-sanad-page">
      {banner && (
        <DynamicBanner title={banner.title} bgImage={banner.images} bgImageMobile={banner.mobile_images} />
      )}

      {cardData && (
        <DynamicPdfCard
          heading={cardData.heading}
          images={cardData.images || []}
          documents={cardData.documents || []}
        />
        
      )}
      </section>
    </>
  );
};

export default EnvironmentalClearance;
